export const thousandSeparator = (
  value: number,
  locale: string = "en-US",
  options?: Intl.NumberFormatOptions,
): string => {
  return new Intl.NumberFormat(locale, {
    style: "decimal",
    ...options,
  }).format(value);
};
